import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/css/css.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/manipulation/empty/empty.js";
import "dabbyjs/src/manipulation/remove/remove.js";

let files = [];

export default (nav, obj, config) => {
	nav.on("change", () => {

		// render table
		const table = $("<table>", {"class": "hashform__table"}).append(
			$("<tr>")
				.append($("<th>", {text: config.translations.filename}))
				.append($("<th>", {text: config.translations.hash}))
				.append($("<th>", {text: config.translations.remove})
				.css("text-align", "center"))
		);
		files.forEach((item, i) => {

			// render heading - scraped items that could not be fetched have no type
			let content = $("<h3>", {
				text: item.name,
				"class": "hashform__table-heading icon-" + ((item.type || "").includes("video/") ? "video" : "img")
			});

			// render tags
			item.tags?.forEach(item => {
				if (typeof config.tags[item] !== "undefined") {
					content.append($("<span>", {
						"class": "hashform__table-heading-tag",
						text: config.tags[item]['name'],
						title: config.tags[item]['title']
					}));
				}
			});

			// scraped items that could not be fetched have no hash to show
			const hash = item.pdq || item.md5;

			// put the table row together
			const row = $("<tr>")
				.append(
					$("<td>").append(content)
				)
				.append($("<td>", {text: hash ? hash.substring(0, 8) + "xxxxxxxx" : "-"}))
				.append($("<td>").append($("<div>", {
					"class": "hashform__table-remove icon-close",
					text: "Remove",
					click: () => {
						files.splice(i, 1);
						if (files.length === 0) {
							table.remove();
							$("#hashform-images").prop("checked", true).trigger("change");
							$("#hashform-images-review").addClass("hashform__link--hide");
						} else {
							nav.trigger("change");
						}
					}
				})));
			
			table.append(row);
		});
		obj.empty().append(table);
	});
};

export const getfiles = () => files;

export const setfiles = items => files.splice(0, files.length, ...items);